import { render, staticRenderFns } from "./updateMobile.vue?vue&type=template&id=18ca9b62"
import script from "./updateMobile.vue?vue&type=script&lang=js"
export * from "./updateMobile.vue?vue&type=script&lang=js"
import style0 from "./updateMobile.vue?vue&type=style&index=0&id=18ca9b62&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports